import RegistrationScreen from './RegistrationScreen';
export default RegistrationScreen;
